<template>
  <p class="coverage-strip" :data-testid="testid">
    <svg class="coverage-strip__icon" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">
      <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5" />
      <rect x="7.25" y="7" width="1.5" height="4.5" rx="0.75" fill="currentColor" />
      <circle cx="8" cy="4.75" r="0.95" fill="currentColor" />
    </svg>
    <span class="coverage-strip__text">{{ text }}</span>
  </p>
</template>

<script>
export default {
  name: 'CoverageStrip',
  props: {
    text: { type: String, required: true },
    testid: { type: String, default: 'msc-coverage-strip' }
  }
}
</script>

<style scoped>
.coverage-strip {
  --coverage-strip-bg: var(--cs-signal-mist, #E8F3F4);
  --coverage-strip-fg: #3B5A60;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  width: 100%;
  margin: var(--space-2, 8px) 0 var(--space-4, 16px);
  padding: 12px;
  border-radius: var(--radius-md, 8px);
  background: var(--coverage-strip-bg);
  color: var(--coverage-strip-fg);
  font-size: 14px;
  line-height: 1.4;
  /* Static, never sticky; text wraps, never truncates. */
  position: static;
  white-space: normal;
  overflow-wrap: anywhere;
}

[data-theme="dark"] .coverage-strip {
  --coverage-strip-fg: #C4D9DC;
}

.coverage-strip__icon {
  flex: 0 0 16px;
  margin-top: 2px;
}

.coverage-strip__text {
  min-width: 0;
}
</style>
